module.exports = __webpack_public_path__ + "img/6.c3831133.jpg";